import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/icon-excel.svg'


const _hoisted_1 = { class: "flex flex-col gap-8" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row justify-between sm:items-center items-start gap-4" }
const _hoisted_3 = { class: "flex flex-row w-full sm:w-96 gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-[16px]" }, "Excel", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "" }

import { computed, defineComponent, ref, Ref, markRaw } from "vue";
import ShareholderDividendsTable from "@/components/organisms/ShareholderDividendsTable.vue";
import ShareholderSharesTable from "@/components/organisms/ShareholderSharesTable.vue";
import { DividendService } from "@/services/dividends/dividendService";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholderSharesTab',
  setup(__props) {

const viewActive: Ref<number> = ref(1);

const dividendService = new DividendService();

const route = useRoute();

const downloadExcel = () => {
  const shareholderId = +route.params.id;
  dividendService.downloadDividendsPaymentsList(shareholderId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", {
          class: _normalizeClass(["text-[16px] w-full cursor-pointer", [
            viewActive.value == 1
              ? 'font-bold border-selected '
              : 'border-unselected',
          ]]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (viewActive.value = 1))
        }, " Últimos movimientos ", 2),
        _createElementVNode("p", {
          class: _normalizeClass(["text-[16px] w-full cursor-pointer", [
            viewActive.value == 2 ? 'font-bold border-selected' : 'border-unselected',
          ]]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (viewActive.value = 2))
        }, " Dividendos ", 2)
      ]),
      (viewActive.value == 2)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "w-full sm:w-48 btn btn-excel h-[33px] flex gap-2 lg:mt-0",
            onClick: downloadExcel
          }, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (viewActive.value == 1)
        ? (_openBlock(), _createBlock(ShareholderSharesTable, { key: 0 }))
        : _createCommentVNode("", true),
      (viewActive.value == 2)
        ? (_openBlock(), _createBlock(ShareholderDividendsTable, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})